import $ from "jquery";

export const DisplayMsg = (code, msg) => {
  if (code === "1") {
    document.getElementById("loader").style.display = "none";
    document.getElementById("success").style.display = "block";
    document.getElementById("SuccessText").innerHTML = msg;
    $(".successMessage").fadeIn(300).delay(1500).fadeOut(400);
  } else if (code === "2") {
    document.getElementById("loader").style.display = "none";
    document.getElementById("error").style.display = "block";
    document.getElementById("ErrorText").innerText = msg;
    $(".errorMessage").fadeIn(300).delay(1500).fadeOut(400);
  }
};
